"use client";

import React, { useEffect, useMemo, useRef, useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { checkerArray } from "@/utilities/checker";
import { useRouter } from "next/navigation";
import {
  Autoplay,
  Navigation,
  FreeMode,
  Scrollbar,
  A11y,
  Pagination,
} from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { axiosGetOverallProductRatings, axiosGetWishlist, AxiosPost } from "@/utilities/axioscall";

import { AK } from "@/constants";
import toast from "react-hot-toast";
import FadeLoader from "react-spinners/FadeLoader";
import SvgIcons from "@/components/themes/SvgIcons";
import { Star } from "lucide-react";
import Image from "next/image";
import Link from "next/link";
import { getAssetsBaseUrl, getCurrencySymbol } from "@/services/storeService";
import Baby1svg from "@/public/assets/images/home/baby1.svg";
import Baby6svg from "@/public/assets/images/home/baby6.svg";
import Baby7svg from "@/public/assets/images/home/baby7.svg";
import Baby8svg from "@/public/assets/images/home/baby8.svg";
import bg from "@/public/assets/images/home/bg.png";
import { ChevronLeft, ChevronRight } from 'lucide-react'

import Babygirl from "@/public/assets/images/home/babygirl.svg";
import img1 from "@/public/assets/images/home/one.png";
import img2 from "@/public/assets/images/home/two.png";
import img3 from "@/public/assets/images/home/three.png";

import crol1 from "@/public/assets/images/home/cor1.svg";
import crol2 from "@/public/assets/images/home/cor2.svg";
import crol3 from "@/public/assets/images/home/cor3.svg";
import crol5 from "@/public/assets/images/home/cor5.svg";
import crol6 from "@/public/assets/images/home/cor6.svg";
import crol7 from "@/public/assets/images/home/cor7.svg";

import cor1 from "@/public/assets/images/home/cor1.png";
import cor2 from "@/public/assets/images/home/cor2.png";
import cor3 from "@/public/assets/images/home/cor3.png";
import cor4 from "@/public/assets/images/home/cor4.png";
import cor5 from "@/public/assets/images/home/cor5.png";
import cor6 from "@/public/assets/images/home/cor6.png";
import { addtowishlist } from "@/clicks/wishlistClicks";

const certifications = [
  { id: 1, image: cor1, alt: "Food Grade Silicone" },
  { id: 2, image: cor2, alt: "Safe for Children" },
  { id: 3, image: cor3, alt: "RoHS Certified" },
  { id: 4, image: cor4, alt: "BPA Free" },
  { id: 5, image: cor5, alt: "Microwave Oven Safe" },
  { id: 6, image: cor6, alt: "Food Safe" },
];


// ========== MAIN HOMEPAGE COMPONENT ==========
const Homepage = ({
  categoryListData,
  featuredcategoriesListData,
  bestsellersListData,
  topratedListData,
}: {
  categoryListData: any;
  featuredcategoriesListData: any;
  bestsellersListData: any;
  topratedListData: any;
}) => {
  const router = useRouter();
  if (!router) return null;

  const assets = `${getAssetsBaseUrl()}`
  const productimage = "";
  const [hoveredProductId, setHoveredProductId] = useState(null);
  const [productwishlistData, setproductwishlistData] = useState<any[]>([]);
  const store = process.env.NEXT_PUBLIC_STORE_NAME || "Store";

  const navigate = (moveon: string) => {
    router.push(moveon);
  };

  const viewproductinfo = (product: any) => {
    navigateToDynamicPage(product.seo_url);
  };

  const navigateToDynamicPage = (seoUrl: string) => {
    router.push(`/p/${seoUrl}`);
  };

  const [formValues, setFormValues] = useState({
    newsemail: "",
    newsemailError: false,
    formloading: false,
  });

  const handleSubmit = async (e: any) => {
    e.preventDefault();

    var error = false;

    if (formValues.newsemail == "") {
      handleChange({
        target: {
          value: true,
          name: "newsemailError",
        },
      });

      error = true;
    } else {
      handleChange({
        target: {
          value: false,
          name: "newsemailError",
        },
      });
    }

    if (error) return;

    handleChange({
      target: {
        value: true,
        name: "formloading",
      },
    });
    var formdata = {
      email: formValues.newsemail,
    };
    return await AxiosPost(AK.NEWSLETTERFORMAPI, formdata)
      .then((res: any) => {
        if (res != typeof undefined && res.data != typeof undefined) {
          if (res?.data) {
            notify();
            setFormValues({
              newsemail: "",
              newsemailError: false,
              formloading: false,
            });
            handleChange({
              target: {
                value: false,
                name: "formloading",
              },
            });

            return true;
          } else {
            notifyerror("Newsletter validation error.");
          }
        }

        handleChange({
          target: {
            value: false,
            name: "formloading",
          },
        });
        return true;
      })
      .catch((error) => {
        handleChange({
          target: {
            value: false,
            name: "formloading",
          },
        });
        return false;
      });
  };

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  const notify = () =>
    toast.success("Newsletter subscribed successfully.", {
      style: {
        border: "1px solid #00b852",
        padding: "16px",
        color: "#00b852",
      },
      iconTheme: {
        primary: "#00b852",
        secondary: "#FFFAEE",
      },
    });

  const notifyerror = (msg: any) =>
    toast.error(msg, {
      style: {
        border: "1px solid #cc0000",
        padding: "16px",
        color: "#cc0000",
      },
      iconTheme: {
        primary: "#cc0000",
        secondary: "#FFFAEE",
      },
    });

  const mainCategories = categoryListData?.filter(
    (category: any) => category.parent_id === 0
  );

  mainCategories?.sort((a: any, b: any) => a.id - b.id);

  const [pageinit, setPageInit] = useState(false);
  const [productoverallratingData, setproductoverallratingData] = useState<any[]>([]);

  useEffect(() => {
    if (!pageinit) {
      setPageInit(true);
      axiosGetOverallProductRatings(setproductoverallratingData);
      axiosGetWishlist(setproductwishlistData);
    }
  }, [pageinit]);

  const getProductRating = (productId: any) => {
    const productRating = productoverallratingData.find(
      (prod) => prod.product_id === productId
    )?.average_rating;

    return productRating ? parseFloat(productRating).toFixed(1) : "0.0";
  };

  const ageCards = [
    // { svg: Baby1svg },
    // { svg: Baby2svg },
    // { svg: Baby3svg },
    // { svg: Baby4svg },
    // { svg: Baby5svg },
    { svg: Baby6svg },
    { svg: Baby8svg },
    { svg: Baby7svg },

  ];

  const MARQUEE_TEXT = "100% TRUSTED & SAFE PRODUCTS - SHOP WITH CONFIDENCE";

  const combos = [
    { title: 'Feeding Trainer - Combo' },
    { title: 'Bath of Joy - Combo' },
    { title: 'Combo - 3' },
    { title: 'Combo - 4' },
    { title: 'Combo - 5' },
    { title: 'Combo - 6' },
  ];

  const badges = [crol1, crol2, crol3, crol5, crol6, crol7];

  const scrollRef = useRef(null);

  const icons = [
    { id: 1, src: crol1, alt: "Food Grade Silicone" },
    { id: 2, src: crol2, alt: "Safe for Children" },
    { id: 3, src: crol3, alt: "RoHS" },
    { id: 5, src: crol5, alt: "BPA Free" },
    { id: 6, src: crol6, alt: "Microwave Oven Safe" },
    { id: 7, src: crol7, alt: "Food Safe" },
  ];

  const testimonials = [
    {
      content: "As a new mom, I was terrified of trying random baby products online. But this site made it easy — clear info, safe ingredients, and fast delivery. My baby's skin finally stopped reacting.",
      author: "Priya R.",
      location: "Chennai"
    },
    {
      content: "As a new mom, I was terrified of trying random baby products online. But this site made it easy — clear info, safe ingredients, and fast delivery. My baby's skin finally stopped reacting. ",
      author: "Priya R.",
      location: "Chennai"
    },
    {
      content: "As a new mom, I was terrified of trying random baby products online. But this site made it easy — clear info, safe ingredients, and fast delivery. My baby's skin finally stopped reacting.",
      author: "Priya R.",
      location: "Chennai"
    },
    {
      content: "As a new mom, I was terrified of trying random baby products online. But this site made it easy — clear info, safe ingredients, and fast delivery. My baby's skin finally stopped reacting.",
      author: "Priya R.",
      location: "Chennai"
    }
  ]





  const productsUnder499 = useMemo(() => {
    const allProducts: any[] = [];

    // Collect products from categoryListData
    categoryListData?.forEach((category: any) => {
      if (category.products && Array.isArray(category.products)) {
        category.products.forEach((product: any) => {
          if (product.sp < 299) {
            allProducts.push(product);
          }
        });
      }
    });

    // Collect products from featuredcategoriesListData
    featuredcategoriesListData?.forEach((category: any) => {
      if (category.products && Array.isArray(category.products)) {
        category.products.forEach((product: any) => {
          if (product.sp < 299) {
            allProducts.push(product);
          }
        });
      }
    });

    // Collect products from bestsellersListData
    if (bestsellersListData && Array.isArray(bestsellersListData)) {
      bestsellersListData.forEach((product: any) => {
        if (product.sp < 299) {
          allProducts.push(product);
        }
      });
    }

    // Collect products from topratedListData
    if (topratedListData && Array.isArray(topratedListData)) {
      topratedListData.forEach((product: any) => {
        if (product.sp < 299) {
          allProducts.push(product);
        }
      });
    }

    // Remove duplicates based on product id
    const uniqueProducts = allProducts.filter((product, index, self) =>
      index === self.findIndex((p) => p.id === product.id)
    );

    return uniqueProducts;
  }, [categoryListData, featuredcategoriesListData, bestsellersListData, topratedListData]);









  return (<>
    <section>
      <h1 className="text-[28px] md:text-[36px] font-bold text-center text-white py-4 sr-only">
        Safe Baby Products for Everyday Parenting
      </h1>
      {/* ========== BANNER SECTION ========== */}
      <Swiper
        className="mySwiper2 mt-md-3 mb-1 mt-0"
        modules={[Pagination, Autoplay]}
        spaceBetween={50}
        pagination={{ clickable: true }}
        loop={true}
        autoplay={{
          delay: 4500,
          disableOnInteraction: false,
        }}
      >
        {[
          {
            href: "/products/baby-products",
            desktop:
              "https://assetsvilva.blr1.cdn.digitaloceanspaces.com/ecomsaas/redisapi/BO21H1191224/uploads/VHydpqRL9N6g7eVGCJ9AnHdO8uDWIZbJAqVsezbE.webp",
            mobile:
              "https://assetsvilva.blr1.cdn.digitaloceanspaces.com/ecomsaas/redisapi/BO21H1191224/uploads/4PoxCRsVCCKWKARStNb6Y8M7fe2o3c4C6JOB8X5J.webp",
          },
          {
            href: "/products/baby-products",
            desktop:
              "https://assetsvilva.blr1.cdn.digitaloceanspaces.com/ecomsaas/redisapi/BO21H1191224/uploads/i7UzjIacbhE578s3Do42Kyr7TpGZfzs3sF97kWFl.webp",
            mobile:
              "https://assetsvilva.blr1.cdn.digitaloceanspaces.com/ecomsaas/redisapi/BO21H1191224/uploads/0JOFriKTEn7i7C8dVf8korsroBQB6UbdaEDK97AW.webp",
          },
          {
            href: "/products/baby-products",
            desktop:
              "https://assetsvilva.blr1.cdn.digitaloceanspaces.com/ecomsaas/redisapi/BO21H1191224/uploads/Z9g0N2OtAG4bnE2ESZJ1xkfWiBQ4ToUS6kJRmmxP.webp",
            mobile:
              "https://assetsvilva.blr1.cdn.digitaloceanspaces.com/ecomsaas/redisapi/BO21H1191224/uploads/LyhkNFyv3GmZCRfuWPizN9H5KKhWkdtvvpr2lMPh.webp",
          },
        ].map((banner, index) => {
          const isLcpSlide = index === 0;
          return (
          <SwiperSlide key={index}>
            <div style={{ height: "100%" }}>
              <a href={banner.href} className="block w-full relative overflow-hidden">
                <Image
                  src={banner.desktop}
                  alt="Home Banner - Desktop"
                  width={1920}
                  height={1080}
                  quality={75}
                  sizes="100vw"
                  className="hidden md:block object-cover w-full h-full"
                  priority={isLcpSlide}
                  loading={isLcpSlide ? "eager" : "lazy"}
                  fetchPriority={isLcpSlide ? "high" : "auto"}
                />

                <Image
                  src={banner.mobile}
                  alt="Home Banner - Mobile"
                  width={1920}
                  height={1080}
                  quality={75}
                  sizes="100vw"
                  className="md:hidden object-cover w-full h-full"
                  priority={isLcpSlide}
                  loading={isLcpSlide ? "eager" : "lazy"}
                  fetchPriority={isLcpSlide ? "high" : "auto"}
                />
              </a>
            </div>
          </SwiperSlide>
        )})}
      </Swiper>

      {/* ========== SHOP BY AGE SECTION ========== */}
      {/* <motion.section
        className="w-full flex flex-col items-center gap-6 bg-[#F7F4FB] py-[40px]"
        variants={staggerContainer}
        whileInView="show"
      >
        <div>
          <p className="text-[40px] text-black text-center font-bold" style={{ fontFamily: "Lato-Regular" }}>Shop by Age</p>
        </div>
        <motion.div
          className="grid lg:grid-cols-3 md:grid-cols-3 grid-cols-2 lg:gap-[50px] gap-[20px]"
          variants={fadeIn}
        >
          {ageCards.map((card, index) => (
            <motion.div
              key={index}
              variants={fadeIn}
              whileHover={{ scale: 1.08 }}
              whileTap={{ scale: 0.96 }}
            >
              <a href="/products/baby-products">
                <Image
                  src={card.svg}
                  alt="age-svg"
                  width={160}
                  height={160}
                  className="object-contain"
                />
              </a>
            </motion.div>
          ))}
        </motion.div>
      </motion.section> */}

      {/* ========== TOP DEALS BY MOMS SECTION ========== */}
      {/* <section className="bg-white relative max-w-7xl mx-auto my-[20px] px-[16px]">
        <center>
          <div className="relative w-fit mb-[25px]">
            <h2 className="pb-4 pt-4 text-[#000000] text-[32px] font-semibold" style={{ fontFamily: "Lato-Regular" }}>
              Combo Offers
            </h2>
            <div className="absolute top-4 -right-6">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="25"
                height="29"
                viewBox="0 0 25 29"
                fill="none"
                className="animate-[random-blink_3s_ease-in-out_infinite]"
              >
                <path
                  d="M12.4552 0C12.4552 0 11.0368 13.4372 0 14.3672C11.0368 15.2965 12.4552 28.7344 12.4552 28.7344C12.4552 28.7344 13.8742 15.2965 24.9103 14.3672C13.8742 13.4372 12.4552 0 12.4552 0Z"
                  fill="#7738CE"
                />
              </svg>
            </div>
          </div>
        </center>

        <div className="relative w-full">
          <button type="button" aria-label="Previous top deals" className="swiper-button-prev-topdeals shadow-md !absolute left-2 top-1/2 -translate-y-1/2 z-10 w-9 h-9 bg-white text-black rounded-full flex items-center justify-center hover:bg-white/80 transition-all hover:scale-110 active:scale-95">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="m15 18-6-6 6-6" />
            </svg>
          </button>

          <button type="button" aria-label="Next top deals" className="swiper-button-next-topdeals shadow-md !absolute right-2 top-1/2 -translate-y-1/2 z-10 !w-9 h-9 bg-white text-black rounded-full flex items-center justify-center hover:bg-white/80 transition-all hover:scale-110 active:scale-95">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="m9 18 6-6-6-6" />
            </svg>
          </button>

          <Swiper
            modules={[Autoplay, Navigation]}
            spaceBetween={10}
            slidesPerView={2}
            loop={true}
            navigation={{
              nextEl: '.swiper-button-next-topdeals',
              prevEl: '.swiper-button-prev-topdeals',
            }}
            breakpoints={{
              400: { slidesPerView: 2, spaceBetween: 10 },
              640: { slidesPerView: 3, spaceBetween: 15 },
              768: { slidesPerView: 3, spaceBetween: 20 },
              1024: { slidesPerView: 4, spaceBetween: 25 },
              1280: { slidesPerView: 4, spaceBetween: 30 },
            }}
          >
            {featuredcategoriesListData[0]?.products?.map((product: any) => {
              const imageUrls = product?.imageurl?.split(",") || [];
              const defaultImage = checkerArray(imageUrls, 1) ? imageUrls[0].trim() : "";
              const hoverImage = checkerArray(imageUrls, 2) ? imageUrls[1].trim() : defaultImage;

              return (
                <SwiperSlide key={product.id} className="group">
                  <div className="bg-white overflow-hidden cursor-pointer">
                    <div
                      className="relative overflow-hidden rounded-[8px] w-full lg:h-[328px] md:h-[258px] h-[200px] object-cover"
                      onClick={() => viewproductinfo(product)}
                      onMouseEnter={() => setHoveredProductId(product.id)}
                      onMouseLeave={() => setHoveredProductId(null)}
                    >
                      <Image
                        src={
                          hoveredProductId === product.id
                            ? `${assets}${productimage}${hoverImage}`
                            : `${assets}${productimage}${defaultImage}`
                        }
                        alt={product.name}
                        fill
                        className="rounded-[8px] object-cover transition-transform duration-500 ease-in-out hover:scale-110 border-2 border-gray-100"
                        onError={(e) => {
                          e.currentTarget.src = "/ecomsaas-assets/images/no-image.webp";
                        }}
                        loading="lazy"
                      />

                      <div className="absolute bottom-2 right-2 bg-black/20 p-2 rounded-full">
                        <svg
                          className="cursor-pointer"
                          onClick={(e) => {
                            e.stopPropagation();
                            addtowishlist(
                              product,
                              productwishlistData,
                              setproductwishlistData,
                              navigate
                            );
                          }}
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="21"
                          viewBox="0 0 20 21"
                          fill={
                            productwishlistData?.includes(
                              product?.id?.toString()
                            )
                              ? "#f45440"
                              : "none"
                          }
                        >
                          <path
                            d="M15.8333 11.9202C17.075 10.7035 18.3333 9.24521 18.3333 7.33687C18.3333 6.1213 17.8504 4.95551 16.9909 4.09597C16.1314 3.23643 14.9656 2.75354 13.75 2.75354C12.2833 2.75354 11.25 3.17021 9.99999 4.42021C8.74999 3.17021 7.71666 2.75354 6.24999 2.75354C5.03441 2.75354 3.86863 3.23643 3.00908 4.09597C2.14954 4.95551 1.66666 6.1213 1.66666 7.33687C1.66666 9.25354 2.91666 10.7119 4.16666 11.9202L9.99999 17.7535L15.8333 11.9202Z"
                            stroke={
                              productwishlistData?.includes(
                                product?.id?.toString()
                              )
                                ? "#f45440"
                                : "#fff"
                            }
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>

                      {product.mrp !== product.sp && product.mrp > 0 && (
                        <div className="absolute top-[10px] left-0 bg-[#E849A0] text-white text-sm font-bold px-3 py-2">
                          {(((product.mrp - product.sp) / product.mrp) * 100).toFixed(0)}% OFF
                        </div>
                      )}
                    </div>

                    <div className="mt-[16px] space-y-[8px]">
                      <p className="text-[16px] font-medium text-[#000000] truncate capitalize">
                        {product.name}
                      </p>

                      <div className="flex items-center justify-between">
                        <div className="flex items-center justify-center gap-2">
                          <p className="text-lg font-semibold text-[#000000]">
                            Rs.{product.sp}
                          </p>
                          {product.mrp !== product.sp && (
                            <p className="text-[16px] text-[#000000]/50 line-through">
                              Rs.{product.mrp}
                            </p>
                          )}
                        </div>
                        <div className="flex items-center gap-1">
                          <SvgIcons.ProduectStar />
                          <p className="text-[16px]">4.5</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
      </section> */}

      {/* ========== BABY PRODUCTS SECTION (FIRST FEATURED CATEGORY) ========== */}
      {featuredcategoriesListData[0] && (
        <section className="bg-white relative max-w-7xl mx-auto md:my-[40px] my-[30px] px-[16px] md:py-[40px] py-[20px]">
          <div className="flex items-center justify-between">
            <div className="invisible md:block hidden">
              <a href={`/products/${featuredcategoriesListData[0]?.seo_url}`}>
                <button>View All</button>
              </a>
            </div>
            <div className="relative w-fit md:mb-[25px]">
              <h2 className="pb-4 pt-4 text-[#000000] text-[32px] font-semibold" style={{ fontFamily: "Lato-Regular" }}>
                {featuredcategoriesListData[0]?.name}
              </h2>
            </div>
            <div>
              <a href={`/products/${featuredcategoriesListData[0]?.seo_url}`}>
                <button className="text-primary border-b border-primary font-medium">View All</button>
              </a>
            </div>
          </div>

          <div className="relative w-full">
            <button type="button" aria-label="Previous products" className="swiper-button-prev-section0 shadow-md !absolute left-2 top-1/2 -translate-y-1/2 z-10 w-9 h-9 bg-white text-black rounded-full flex items-center justify-center hover:bg-white/80 transition-all hover:scale-110 active:scale-95">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="m15 18-6-6 6-6" />
              </svg>
            </button>

            <button type="button" aria-label="Next products" className="swiper-button-next-section0 shadow-md !absolute right-2 top-1/2 -translate-y-1/2 z-10 !w-9 h-9 bg-white text-black rounded-full flex items-center justify-center hover:bg-white/80 transition-all hover:scale-110 active:scale-95">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="m9 18 6-6-6-6" />
              </svg>
            </button>

            <Swiper
              modules={[Autoplay, Navigation]}
              spaceBetween={10}
              slidesPerView={2}
              loop={true}
              navigation={{
                nextEl: '.swiper-button-next-section0',
                prevEl: '.swiper-button-prev-section0',
              }}
              breakpoints={{
                400: { slidesPerView: 2, spaceBetween: 10 },
                640: { slidesPerView: 3, spaceBetween: 15 },
                768: { slidesPerView: 3, spaceBetween: 20 },
                1024: { slidesPerView: 4, spaceBetween: 25 },
                1280: { slidesPerView: 4, spaceBetween: 30 },
              }}
            >
              {featuredcategoriesListData[1]?.products?.map((product: any) => {
                const imageUrls = product?.imageurl?.split(",") || [];
                const defaultImage = checkerArray(imageUrls, 1) ? imageUrls[0].trim() : "";
                const hoverImage = checkerArray(imageUrls, 2) ? imageUrls[1].trim() : defaultImage;

                return (
                  <SwiperSlide key={product.id} className="group">
                    <div className="bg-white overflow-hidden cursor-pointer">
                      <div
                        className="relative overflow-hidden rounded-[8px] w-full lg:h-[328px] md:h-[258px] h-[200px] object-cover"
                        onClick={() => viewproductinfo(product)}
                        onMouseEnter={() => setHoveredProductId(product.id)}
                        onMouseLeave={() => setHoveredProductId(null)}
                      >
                        <Image
                          src={
                            hoveredProductId === product.id
                              ? `${assets}${productimage}${hoverImage}`
                              : `${assets}${productimage}${defaultImage}`
                          }
                          alt={product.name}
                          fill
                          className="rounded-[8px] object-cover transition-transform duration-500 ease-in-out hover:scale-110 border-2 border-gray-100"
                          onError={(e) => {
                            e.currentTarget.src = "/ecomsaas-assets/images/no-image.webp";
                          }}
                          loading="lazy"
                        />

                        <div className="absolute bottom-2 right-2 bg-black/20 p-2 rounded-full">
                          <svg
                            className="cursor-pointer"
                            onClick={(e) => {
                              e.stopPropagation();
                              addtowishlist(
                                product,
                                productwishlistData,
                                setproductwishlistData,
                                navigate
                              );
                            }}
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="21"
                            viewBox="0 0 20 21"
                            fill={
                              productwishlistData?.includes(
                                product?.id?.toString()
                              )
                                ? "#f45440"
                                : "none"
                            }
                          >
                            <path
                              d="M15.8333 11.9202C17.075 10.7035 18.3333 9.24521 18.3333 7.33687C18.3333 6.1213 17.8504 4.95551 16.9909 4.09597C16.1314 3.23643 14.9656 2.75354 13.75 2.75354C12.2833 2.75354 11.25 3.17021 9.99999 4.42021C8.74999 3.17021 7.71666 2.75354 6.24999 2.75354C5.03441 2.75354 3.86863 3.23643 3.00908 4.09597C2.14954 4.95551 1.66666 6.1213 1.66666 7.33687C1.66666 9.25354 2.91666 10.7119 4.16666 11.9202L9.99999 17.7535L15.8333 11.9202Z"
                              stroke={
                                productwishlistData?.includes(
                                  product?.id?.toString()
                                )
                                  ? "#f45440"
                                  : "#fff"
                              }
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>

                        {product.mrp !== product.sp && product.mrp > 0 && (
                          <div className="absolute top-[10px] left-0 bg-[#E849A0] text-white text-sm font-bold px-3 py-2">
                            {(((product.mrp - product.sp) / product.mrp) * 100).toFixed(0)}% OFF
                          </div>
                        )}
                      </div>

                      <div className="mt-[16px] space-y-[8px]">
                        <p className="text-[16px] font-medium text-[#000000] truncate capitalize">
                          {product.name}
                        </p>

                        <div className="flex items-center justify-between">
                          <div className="flex items-center justify-center gap-2">
                            <p className="text-lg font-semibold text-[#000000]">
                              Rs.{product.sp}
                            </p>
                            {product.mrp !== product.sp && (
                              <p className="text-[16px] text-[#000000]/50 line-through">
                                Rs.{product.mrp}
                              </p>
                            )}
                          </div>
                          <div className="flex items-center gap-1">
                            <SvgIcons.ProduectStar />
                            <p className="text-[16px]">4.5</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                );
              })}
            </Swiper>
          </div>
        </section>
      )}

      {/* ========== MARQUEE SECTION ========== */}
      <div className="w-full bg-[#E4E4FE] py-4 overflow-hidden">
        <div className="relative flex overflow-x-hidden py-2">
          <div className="animate-marquee whitespace-nowrap flex items-center" >
            <span className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#A2A4EE] mx-8" style={{ fontFamily: "Lato-Regular" }}>
              {MARQUEE_TEXT}
            </span>
            <span className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#A2A4EE] mx-8" style={{ fontFamily: "Lato-Regular" }}>
              {MARQUEE_TEXT}
            </span>
            <span className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#A2A4EE] mx-8" style={{ fontFamily: "Lato-Regular" }}>
              {MARQUEE_TEXT}
            </span>
            <span className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#A2A4EE] mx-8" style={{ fontFamily: "Lato-Regular" }}>
              {MARQUEE_TEXT}
            </span>
          </div>
          <div className="absolute top-0 animate-marquee2 whitespace-nowrap flex items-center">
            <span className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#A2A4EE] mx-8">
              {MARQUEE_TEXT}
            </span>
            <span className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#A2A4EE] mx-8">
              {MARQUEE_TEXT}
            </span>
            <span className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#A2A4EE] mx-8">
              {MARQUEE_TEXT}
            </span>
            <span className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#A2A4EE] mx-8">
              {MARQUEE_TEXT}
            </span>
          </div>
        </div>
      </div>

      {/* ========== COMBO SECTION ========== */}
      {/* <div className="w-full bg-[#FFFFFF] py-12 px-4 max-w-7xl mx-auto my-[20px]">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-8 md:gap-10 lg:gap-12">
            {combos.map((combo, index) => (
              <div
                key={index}
                className="flex justify-center items-center"
              >
                <div className="group relative md:w-[170px] w-[150px] md:h-[170px] h-[150px] cursor-pointer">
                  <div className="absolute inset-0 rounded-full overflow-hidden shadow-lg transition-all duration-500 ease-in-out group-hover:scale-110 group-hover:shadow-2xl">
                    <div className="absolute inset-0">
                      <Image
                        src={bg}
                        alt="Background"
                        fill
                        className="object-cover transition-all duration-500 group-hover:scale-110"
                      />
                    </div>
                    <div className="absolute inset-0 bg-white/50 group-hover:bg-white/40 transition-all duration-500"></div>
                  </div>

                  <div className="absolute inset-0 flex items-center justify-center p-6">
                    <h3 className="text-center text-[20px] font-semibold text-[#2C0B47] transition-all duration-500 group-hover:scale-105 group-hover:text-primary z-10">
                      {combo.title}
                    </h3>
                  </div>

                  <div className="absolute inset-0 rounded-full border-2 border-transparent group-hover:border-pink-300 transition-all duration-500 scale-95 group-hover:scale-105 opacity-0 group-hover:opacity-100"></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div> */}

      {/* ========== Women Essentials SECTION (FIRST FEATURED CATEGORY) ========== */}
      {featuredcategoriesListData[0] && (
        <section className="bg-[#FAF8FC] md:pb-[60px] pb-[30px] px-[16px] md:py-[40px] py-[20px]">
          <div className="bg-[#FAF8FC] relative max-w-7xl mx-auto ">
            <div className="flex items-center justify-between">
              <div className="invisible md:block hidden">
                <a href={`/products/${featuredcategoriesListData[0]?.seo_url}`}>
                  <button>View All</button>
                </a>
              </div>
              <div className="relative w-fit md:mb-[25px]">
                <h2 className="pb-4 pt-4 text-[#000000] text-[32px] font-semibold" style={{ fontFamily: "Lato-Regular" }}>
                  {/* {featuredcategoriesListData[0]?.name} */}
                  Women Essentials
                </h2>
              </div>
              <div>
                <a href={`/products/${featuredcategoriesListData[0]?.seo_url}`}>
                  <button className="text-primary border-b border-primary font-medium">View All</button>
                </a>
              </div>
            </div>

            <div className="relative w-full">
              <button type="button" aria-label="Previous products" className="swiper-button-prev-section0 shadow-md !absolute left-2 top-1/2 -translate-y-1/2 z-10 w-9 h-9 bg-white text-black rounded-full flex items-center justify-center hover:bg-white/80 transition-all hover:scale-110 active:scale-95">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="m15 18-6-6 6-6" />
                </svg>
              </button>

              <button type="button" aria-label="Next products" className="swiper-button-next-section0 shadow-md !absolute right-2 top-1/2 -translate-y-1/2 z-10 !w-9 h-9 bg-white text-black rounded-full flex items-center justify-center hover:bg-white/80 transition-all hover:scale-110 active:scale-95">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="m9 18 6-6-6-6" />
                </svg>
              </button>

              <Swiper
                modules={[Autoplay, Navigation]}
                spaceBetween={10}
                slidesPerView={2}
                loop={true}
                navigation={{
                  nextEl: '.swiper-button-next-section0',
                  prevEl: '.swiper-button-prev-section0',
                }}
                breakpoints={{
                  400: { slidesPerView: 2, spaceBetween: 10 },
                  640: { slidesPerView: 3, spaceBetween: 15 },
                  768: { slidesPerView: 3, spaceBetween: 20 },
                  1024: { slidesPerView: 4, spaceBetween: 25 },
                  1280: { slidesPerView: 4, spaceBetween: 30 },
                }}
              >
                {featuredcategoriesListData[2]?.products?.map((product: any) => {
                  const imageUrls = product?.imageurl?.split(",") || [];
                  const defaultImage = checkerArray(imageUrls, 1) ? imageUrls[0].trim() : "";
                  const hoverImage = checkerArray(imageUrls, 2) ? imageUrls[1].trim() : defaultImage;

                  return (
                    <SwiperSlide key={product.id} className="group">
                      <div className=" overflow-hidden cursor-pointer">
                        <div
                          className="relative overflow-hidden rounded-[8px] w-full lg:h-[328px] md:h-[258px] h-[200px] object-cover"
                          onClick={() => viewproductinfo(product)}
                          onMouseEnter={() => setHoveredProductId(product.id)}
                          onMouseLeave={() => setHoveredProductId(null)}
                        >
                          <Image
                            src={
                              hoveredProductId === product.id
                                ? `${assets}${productimage}${hoverImage}`
                                : `${assets}${productimage}${defaultImage}`
                            }
                            alt={product.name}
                            fill
                            className="rounded-[8px] object-cover transition-transform duration-500 ease-in-out hover:scale-110 border-2 border-gray-100"
                            onError={(e) => {
                              e.currentTarget.src = "/ecomsaas-assets/images/no-image.webp";
                            }}
                            loading="lazy"
                          />

                          <div className="absolute bottom-2 right-2 bg-black/20 p-2 rounded-full">
                            <svg
                              className="cursor-pointer"
                              onClick={(e) => {
                                e.stopPropagation();
                                addtowishlist(
                                  product,
                                  productwishlistData,
                                  setproductwishlistData,
                                  navigate
                                );
                              }}
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="21"
                              viewBox="0 0 20 21"
                              fill={
                                productwishlistData?.includes(
                                  product?.id?.toString()
                                )
                                  ? "#f45440"
                                  : "none"
                              }
                            >
                              <path
                                d="M15.8333 11.9202C17.075 10.7035 18.3333 9.24521 18.3333 7.33687C18.3333 6.1213 17.8504 4.95551 16.9909 4.09597C16.1314 3.23643 14.9656 2.75354 13.75 2.75354C12.2833 2.75354 11.25 3.17021 9.99999 4.42021C8.74999 3.17021 7.71666 2.75354 6.24999 2.75354C5.03441 2.75354 3.86863 3.23643 3.00908 4.09597C2.14954 4.95551 1.66666 6.1213 1.66666 7.33687C1.66666 9.25354 2.91666 10.7119 4.16666 11.9202L9.99999 17.7535L15.8333 11.9202Z"
                                stroke={
                                  productwishlistData?.includes(
                                    product?.id?.toString()
                                  )
                                    ? "#f45440"
                                    : "#fff"
                                }
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </div>

                          {product.mrp !== product.sp && product.mrp > 0 && (
                            <div className="absolute top-[10px] left-0 bg-[#E849A0] text-white text-sm font-bold px-3 py-2">
                              {(((product.mrp - product.sp) / product.mrp) * 100).toFixed(0)}% OFF
                            </div>
                          )}
                        </div>

                        <div className="mt-[16px] space-y-[8px]">
                          <p className="text-[16px] font-medium text-[#000000] truncate capitalize">
                            {product.name}
                          </p>

                          <div className="flex items-center justify-between">
                            <div className="flex items-center justify-center gap-2">
                              <p className="text-lg font-semibold text-[#000000]">
                                Rs.{product.sp}
                              </p>
                              {product.mrp !== product.sp && (
                                <p className="text-[16px] text-[#000000]/50 line-through">
                                  Rs.{product.mrp}
                                </p>
                              )}
                            </div>
                            <div className="flex items-center gap-1">
                              <SvgIcons.ProduectStar />
                              <p className="text-[16px]">4.5</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                  );
                })}
              </Swiper>
            </div>
          </div>
        </section>
      )}

      {/* ========== BANNER IMAGE ========== */}
      <div>
        <div>
          <Link href="/products/baby-products" aria-label="Shop baby products">
            <Image
              src="https://assetsvilva.blr1.cdn.digitaloceanspaces.com/ecomsaas/redisapi/BO21H1191224/uploads/VHydpqRL9N6g7eVGCJ9AnHdO8uDWIZbJAqVsezbE.webp"
              alt="Shop baby products"
              width={1920}
              height={640}
              className="w-full h-auto"
            />
          </Link>
        </div>
      </div>


      {/* ========== BABY PRODUCTS SECTION (FIRST FEATURED CATEGORY) ========== */}
      {productsUnder499.length > 0 && (
        <section className="bg-[#FAF8FC] md:pb-[60px] pb-[30px] px-[16px] md:py-[40px] py-[20px]">
          <div className="bg-[#FAF8FC] relative max-w-7xl mx-auto">
            <div className="flex items-center justify-between">
              <div className="invisible md:block hidden">
                <button>View All</button>
              </div>
              <div className="relative w-fit md:mb-[25px]">
                <h2 className="pb-4 pt-4 text-[#000000] text-[32px] font-semibold" style={{ fontFamily: "Lato-Regular" }}>
                  Best Under Rs. 499
                </h2>
              </div>
              <div>
                <button className="text-primary border-b border-primary font-medium">View All</button>
              </div>
            </div>

            <div className="relative w-full">
              <button type="button" aria-label="Previous products under 499" className="swiper-button-prev-under499 shadow-md !absolute left-2 top-1/2 -translate-y-1/2 z-10 w-9 h-9 bg-white text-black rounded-full flex items-center justify-center hover:bg-white/80 transition-all hover:scale-110 active:scale-95">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="m15 18-6-6 6-6" />
                </svg>
              </button>

              <button type="button" aria-label="Next products under 499" className="swiper-button-next-under499 shadow-md !absolute right-2 top-1/2 -translate-y-1/2 z-10 !w-9 h-9 bg-white text-black rounded-full flex items-center justify-center hover:bg-white/80 transition-all hover:scale-110 active:scale-95">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="m9 18 6-6-6-6" />
                </svg>
              </button>

              <Swiper
                modules={[Autoplay, Navigation]}
                spaceBetween={10}
                slidesPerView={2}
                loop={productsUnder499.length > 4}
                navigation={{
                  nextEl: '.swiper-button-next-under499',
                  prevEl: '.swiper-button-prev-under499',
                }}
                breakpoints={{
                  400: { slidesPerView: 2, spaceBetween: 10 },
                  640: { slidesPerView: 3, spaceBetween: 15 },
                  768: { slidesPerView: 3, spaceBetween: 20 },
                  1024: { slidesPerView: 4, spaceBetween: 25 },
                  1280: { slidesPerView: 4, spaceBetween: 30 },
                }}
              >
                {productsUnder499.map((product: any) => {
                  const imageUrls = product?.imageurl?.split(",") || [];
                  const defaultImage = checkerArray(imageUrls, 1) ? imageUrls[0].trim() : "";
                  const hoverImage = checkerArray(imageUrls, 2) ? imageUrls[1].trim() : defaultImage;

                  return (
                    <SwiperSlide key={product.id} className="group">
                      <div className="overflow-hidden cursor-pointer">
                        <div
                          className="relative overflow-hidden rounded-[8px] w-full lg:h-[328px] md:h-[258px] h-[200px] object-cover"
                          onClick={() => viewproductinfo(product)}
                          onMouseEnter={() => setHoveredProductId(product.id)}
                          onMouseLeave={() => setHoveredProductId(null)}
                        >
                          <Image
                            src={
                              hoveredProductId === product.id
                                ? `${assets}${productimage}${hoverImage}`
                                : `${assets}${productimage}${defaultImage}`
                            }
                            alt={product.name}
                            fill
                            className="rounded-[8px] object-cover transition-transform duration-500 ease-in-out hover:scale-110 border-2 border-gray-100"
                            onError={(e) => {
                              e.currentTarget.src = "/ecomsaas-assets/images/no-image.webp";
                            }}
                            loading="lazy"
                          />

                          <div className="absolute bottom-2 right-2 bg-black/20 p-2 rounded-full">
                            <svg
                              className="cursor-pointer"
                              onClick={(e) => {
                                e.stopPropagation();
                                addtowishlist(
                                  product,
                                  productwishlistData,
                                  setproductwishlistData,
                                  navigate
                                );
                              }}
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="21"
                              viewBox="0 0 20 21"
                              fill={
                                productwishlistData?.includes(
                                  product?.id?.toString()
                                )
                                  ? "#f45440"
                                  : "none"
                              }
                            >
                              <path
                                d="M15.8333 11.9202C17.075 10.7035 18.3333 9.24521 18.3333 7.33687C18.3333 6.1213 17.8504 4.95551 16.9909 4.09597C16.1314 3.23643 14.9656 2.75354 13.75 2.75354C12.2833 2.75354 11.25 3.17021 9.99999 4.42021C8.74999 3.17021 7.71666 2.75354 6.24999 2.75354C5.03441 2.75354 3.86863 3.23643 3.00908 4.09597C2.14954 4.95551 1.66666 6.1213 1.66666 7.33687C1.66666 9.25354 2.91666 10.7119 4.16666 11.9202L9.99999 17.7535L15.8333 11.9202Z"
                                stroke={
                                  productwishlistData?.includes(
                                    product?.id?.toString()
                                  )
                                    ? "#f45440"
                                    : "#fff"
                                }
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </div>

                          {product.mrp !== product.sp && product.mrp > 0 && (
                            <div className="absolute top-[10px] left-0 bg-[#E849A0] text-white text-sm font-bold px-3 py-2">
                              {(((product.mrp - product.sp) / product.mrp) * 100).toFixed(0)}% OFF
                            </div>
                          )}
                        </div>

                        <div className="mt-[16px] space-y-[8px]">
                          <p className="text-[16px] font-medium text-[#000000] truncate capitalize">
                            {product.name}
                          </p>

                          <div className="flex items-center justify-between">
                            <div className="flex items-center justify-center gap-2">
                              <p className="text-lg font-semibold text-[#000000]">
                                Rs.{product.sp}
                              </p>
                              {product.mrp !== product.sp && (
                                <p className="text-[16px] text-[#000000]/50 line-through">
                                  Rs.{product.mrp}
                                </p>
                              )}
                            </div>
                            <div className="flex items-center gap-1">
                              <SvgIcons.ProduectStar />
                              <p className="text-[16px]">4.5</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                  );
                })}
              </Swiper>
            </div>
          </div>
        </section>
      )}

      {/* ========== PEACE OF MIND SECTION ========== */}
      <section className="w-full py-12 px-4 sm:px-6 lg:px-8 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-wrap">
            <div className="md:w-5/12 w-full">
              <div className="relative w-full lg:max-w-[400px] max-w-[600px] aspect-square">
                <Image
                  src={Babygirl}
                  alt="Mother holding baby illustration"
                  fill
                  className="object-contain"
                  priority
                />
              </div>
            </div>

            <div className="md:w-7/12 w-full">
              <h2 className="md:text-[40px] text-[24px] font-bold text-primary text-center">
                Because You Deserve Peace of Mind.
              </h2>

              <p className="text-[#000000]/70 text-[18px] text-center font-semibold lg:text-left leading-[28px]">
                Motherhood is full of choices — but when it comes to safety, there shouldn't be any doubt.
                That's why we handpick every brand, test every ingredient, and make sure every order comes
                with a smile.
              </p>

              <div className="flex items-center gap-x-[24px] justify-center mt-[24px]">
                <div className="flex justify-center items-center">
                  <Image
                    src={img1}
                    alt="Handshake icon"
                    className="w-[180px]"
                  />
                </div>
                <div>
                  <Image
                    src={img2}
                    alt="Handshake icon"
                    className="w-[180px]"
                  />
                </div>
                <div>
                  <Image
                    src={img3}
                    alt="Handshake icon"
                    className="w-[180px]"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="w-full bg-[#FCF8FC] text-[#] rounded-[16px] py-[20px] overflow-hidden my-[20px]">
            <div className="relative flex">
              <div className="flex animate-scroll">
                {certifications.map((cert) => (
                  <div
                    key={`first-${cert.id}`}
                    className="flex-shrink-0 w-20 h-20 md:w-24 md:h-24 lg:w-28 lg:h-28 flex items-center justify-center mx-6 md:mx-8 lg:mx-12"
                  >
                    <Image
                      src={cert.image}
                      alt={cert.alt}
                      width={112}
                      height={112}
                      className="w-full h-full object-contain"
                    />
                  </div>
                ))}
                {certifications.map((cert) => (
                  <div
                    key={`second-${cert.id}`}
                    className="flex-shrink-0 w-20 h-20 md:w-24 md:h-24 lg:w-28 lg:h-28 flex items-center justify-center mx-6 md:mx-8 lg:mx-12"
                  >
                    <Image
                      src={cert.image}
                      alt={cert.alt}
                      width={112}
                      height={112}
                      className="w-full h-full object-contain"
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ========== TESTIMONIALS SECTION ========== */}
      <section className="py-16 px-4 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-7xl mx-auto">
          <h2 className="md:text-[32px] text-[28px] font-bold text-center md:mb-12 mb-6 text-black" style={{ fontFamily: "Lato-Regular" }}>
            What Moms Are Saying
          </h2>

          <div className="relative">
            <Swiper
              modules={[Autoplay, Navigation]}
              spaceBetween={24}
              slidesPerView={1}
              loop={true}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true
              }}
              navigation={{
                prevEl: '.swiper-button-prev-custom',
                nextEl: '.swiper-button-next-custom'
              }}
              breakpoints={{
                640: {
                  slidesPerView: 1,
                  spaceBetween: 20
                },
                768: {
                  slidesPerView: 2,
                  spaceBetween: 24
                },
                1024: {
                  slidesPerView: 3,
                  spaceBetween: 24
                }
              }}
              className="pb-12"
            >
              {testimonials.map((testimonial, index) => (
                <SwiperSlide key={index}>
                  <div
                    className="w-fit h-fit flex flex-col p-[32px] rounded-[40px] border-[2px] space-y-[24px]"
                    style={{
                      borderColor: "rgba(33, 0, 64, 0.05)",
                      background: "radial-gradient(90.52% 90.52% at 50% 9.48%, #FFF 0%, #EEE2EE 100%)",
                    }}
                  >
                    <p className="text-[#000000] text-[16px] leading-relaxed">
                      "{testimonial.content}"
                    </p>

                    <p className="text-[#000000] text-[16px] font-medium text-center md:text-base">
                      - {testimonial.author}, {testimonial.location}
                    </p>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>

            <div className="flex space-x-2 mt-[10px] mx-auto md:justify-start justify-center">
              <button
                type="button"
                className="swiper-button-prev-custom bg-white p-[2px] rounded-full shadow-md"
                aria-label="Previous testimonial"
              >
                <ChevronLeft className="w-6 h-6 text-gray-700" />
              </button>

              <button
                type="button"
                className="swiper-button-next-custom bg-white p-[2px] rounded-full shadow-md"
                aria-label="Next testimonial"
              >
                <ChevronRight className="w-6 h-6 text-gray-700" />
              </button>
            </div>
          </div>
        </div>
      </section>

    </section>
  </>)
};

export default Homepage;
